import { render } from "./dropdown-custom.vue?vue&type=template&id=44db0345"
import script from "./dropdown-custom.vue?vue&type=script&lang=js"
export * from "./dropdown-custom.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Cater-Frontend\\cater\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__